var map = {
	"./footer-links.de-CH.json": 1056,
	"./footer-links.de-DE.json": 1057,
	"./footer-links.en-CA.json": 1058,
	"./footer-links.en-GB.json": 1059,
	"./footer-links.en-IN.json": 1060,
	"./footer-links.en-ME.json": 1061,
	"./footer-links.en-US.json": 1062,
	"./footer-links.es-EM.json": 1063,
	"./footer-links.es-ES.json": 1064,
	"./footer-links.fr-BE.json": 1065,
	"./footer-links.fr-CA.json": 1066,
	"./footer-links.fr-CH.json": 1067,
	"./footer-links.nl-BE.json": 1068,
	"./footer-links.nl-NL.json": 1069,
	"./footer-links.pl-PL.json": 1070,
	"./footer-links.pt-BR.json": 1071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1055;